<template>
  <div>
    <div class="mt-3 mb-3 font-niceone-medium">{{ $t('search.popular_brands') }}</div>
    <div class="grid grid-cols-4 md:flex flex-wrap gap-2 items-center">
      <nuxt-link v-for="(item, index) in trends.popular_manufacturers" :key="`recommended-product-${index}`"
                 :to="$routerUrl(item.seo_url)" @click="onNavigate(item,index)"
                 class="border w-20 h-20 flex flex-center rounded-full overflow-hidden px-1">
        <niceone-image :src="item.image" class="w-full"/>
      </nuxt-link>

    </div>
  </div>
</template>

<script setup>
import {track} from "@/composables/useTrackEvent";
import {TRACKERS} from "@/constants/events";

const emit = defineEmits(['closeSearch']);

defineProps({
  trends: {
    type: Object,
    default: () => ({}),
  },
});

const onNavigate = (item, index = 0, source_name = 'brands') => {
  track(TRACKERS.SEARCH, {item, index, source_name})
  emit('closeSearch', item.keyword)
}
</script>